import React from 'react';
import classes from './Subtitle.module.scss';

export const Subtitle = (props) => {
  return (
    <div className={`${props.className} ${classes.subtitle}`}>{props.text}</div>
  );
}
